// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GuidLookupListResultModel from '../../model/guid-lookup-list-result-model';
import GuidLookupListResultDTO from '../dto/guid-lookup-list-result-dto';
import dtoSchema from '../schemas/guid-lookup-list-result-schema';
import GuidLookupModel from '../../model/guid-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class GuidLookupListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GuidLookupListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => GuidLookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: GuidLookupModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<GuidLookupListResultDTO>): GuidLookupListResultModel;
  static toModel(dto: DeepPartial<GuidLookupListResultDTO> | undefined | null): GuidLookupListResultModel | undefined;
  static toModel(dto: DeepPartial<GuidLookupListResultDTO> | undefined | null): GuidLookupListResultModel | undefined {
    return dto ? new GuidLookupListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GuidLookupListResultModel> | GuidLookupListResultModel): GuidLookupListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as GuidLookupListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GuidLookupListResultModel, can not map to GuidLookupListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
